import Dto from "../../../../../lib/model/service/Dto";

class GetAnalyticsLink extends Dto {

  campaignId;

  constructor(campaignId = '') {
    super('appl\\service\\campaign\\dto\\GetAnalyticsLink');
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

}

export default GetAnalyticsLink;
